var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('v-circle',{staticClass:"mr-2",attrs:{"color":_vm.info.color}}),_c('span',[_vm._v(_vm._s(_vm._f("translate")(_vm.info.title)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }